import { MAP_TYPES } from '@deck.gl/carto';

const TRANSITROUTE_SOURCE_ID = 'transitRouteSource';

const source = {
  id: TRANSITROUTE_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: `transit_route_source`,
};
 
export default source;